// restRequest.js
import axios from 'axios';
import { Toast } from 'vant';

// 创建 Axios 实例，动态设置基础路径
const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_V1 || '', // 使用环境变量中的基础路径
  timeout: 10000, // 超时时间
});

// 请求拦截器
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    config.headers['formToken'] = new Date().getTime(); // 防止表单重复提交
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    Toast({ message: '服务器忙，请稍后再试', position: 'bottom', duration: 1000 });
    return Promise.reject(error);
  }
);

// 公共方法
function handleError(error) {
  console.error('请求错误:', error);
  Toast({ message: '服务器忙，请稍后再试', position: 'bottom', duration: 1000 });
  return null;
}

// RESTful 请求封装
const restRequest  = {
  // GET 请求
  async get(url, params = {}, noIndicator = false) {
    try {
      if (!noIndicator) Toast.loading({ message: '加载中...', forbidClick: true });
      const response = await axiosInstance.get(url, { params });
      Toast.clear();
      return response.data;
    } catch (error) {
      Toast.clear();
      return handleError(error);
    }
  },

  // POST 请求（JSON 格式）
  async postJson(url, data = {}, noIndicator = false) {
    try {
      if (!noIndicator) Toast.loading({ message: '加载中...', forbidClick: true });
      const response = await axiosInstance.post(url, data, {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      });
      Toast.clear();
      return response.data;
    } catch (error) {
      Toast.clear();
      return handleError(error);
    }
  },

  // POST 请求（x-www-form-urlencoded 格式）
  async postForm(url, data = {}, noIndicator = false) {
    try {
      if (!noIndicator) Toast.loading({ message: '加载中...', forbidClick: true });
      const response = await axiosInstance.post(
        url,
        new URLSearchParams(data).toString(),
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      );
      Toast.clear();
      return response.data;
    } catch (error) {
      Toast.clear();
      return handleError(error);
    }
  },

  // POST 请求（x-www-form-urlencoded 格式）
  async putForm(url, data = {}, noIndicator = false) {
    try {
      if (!noIndicator) Toast.loading({ message: '加载中...', forbidClick: true });
      const response = await axiosInstance.put(
        url,
        new URLSearchParams(data).toString(),
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      );
      Toast.clear();
      return response.data;
    } catch (error) {
      Toast.clear();
      return handleError(error);
    }
  },

  // PUT 请求
  async put(url, data = {}, noIndicator = false) {
    try {
      if (!noIndicator) Toast.loading({ message: '加载中...', forbidClick: true });
      const response = await axiosInstance.put(url, data, {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      });
      Toast.clear();
      return response.data;
    } catch (error) {
      Toast.clear();
      return handleError(error);
    }
  },

  // DELETE 请求
  async delete(url, params = {}, noIndicator = false) {
    try {
      if (!noIndicator) Toast.loading({ message: '加载中...', forbidClick: true });
      const response = await axiosInstance.delete(url, { params });
      Toast.clear();
      return response.data;
    } catch (error) {
      Toast.clear();
      return handleError(error);
    }
  },

  // 文件上传
  async upload(url, fileName, file, onProgress, noIndicator = false) {
    try {
      if (!noIndicator) Toast.loading({ message: '上传中...', forbidClick: true });

      const formData = new FormData();
      formData.append(fileName, file, file.name);

      const response = await axiosInstance.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 300000,
        onUploadProgress: (progressEvent) => {
          if (onProgress) {
            const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
            onProgress(percent); // 调用进度回调
          }
        },
      });

      Toast.clear();
      return response.data;
    } catch (error) {
      Toast.clear();
      return handleError(error);
    }
  },
};

export default restRequest;



// WEBPACK FOOTER //
// ./src/utils/restRequest.js